import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const menuItems = [
    { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/dashboard' },
    { icon: 'ri-money-rupee-circle-line', label: 'Finance', path: '/dashboard/finance' },
    { icon: 'ri-file-text-line', label: 'Documents', path: '/dashboard/documents' },
    { icon: 'ri-task-line', label: 'Tasks', path: '/dashboard/tasks' },
    { icon: 'ri-plant-line', label: 'Farming Activities', path: '/dashboard/farming' },
    { icon: 'ri-shield-check-line', label: 'Company Policies', path: '/dashboard/policies' },
    { icon: 'ri-discuss-line', label: 'Discussions', path: '/dashboard/discussions' },
  ];

  return (
    <aside className={`bg-teal-900 text-white transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-64'} flex flex-col`}>
      <div className="p-6 flex items-center justify-between border-b border-teal-800">
        {!isCollapsed && <h2 className="text-xl font-bold">Sparsh</h2>}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-2 hover:bg-teal-800 rounded-lg transition-colors cursor-pointer"
        >
          <i className={`${isCollapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'} text-xl w-5 h-5 flex items-center justify-center`}></i>
        </button>
      </div>

      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.path}>
              <button
                onClick={() => navigate(item.path)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'bg-teal-700 text-white'
                    : 'hover:bg-teal-800 text-teal-100'
                }`}
              >
                <i className={`${item.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
                {!isCollapsed && <span className="text-sm font-medium">{item.label}</span>}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-teal-800">
        <button
          onClick={() => navigate('/')}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-teal-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line text-xl w-5 h-5 flex items-center justify-center"></i>
          {!isCollapsed && <span className="text-sm font-medium">Back to Website</span>}
        </button>
      </div>
    </aside>
  );
}
